import React, { ChangeEvent } from 'react'

import { tuneToChannel } from '../../actions/social/update-play-followers'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { selectAudience } from '../../selectors/session-selectors'
import {
  selectOwnedMatchSlug,
  selectPeersByBroadcastingStatus,
} from '../../selectors/blaster-peer-selectors'
import userManager from '../../services/UserManager'
import { AudienceType } from '../../types'
import { isMobile as getIsMobile } from '../../util/track-utils'
import { SelectOption, SelectWithLabel } from './TextInputWithLabel'

const allAudienceLabels = {
  pub: 'Pub',
  couch: 'Couch',
  solo: 'Solo',
  prod: 'Pro',
  follow: 'Follow',
}
const mobileAudiences: AudienceType[] = ['solo', 'follow']
const basicAudienceDisplayOrder: AudienceType[] = ['pub', 'couch', 'solo', 'follow']
const allAudienceDisplayOrder: AudienceType[] = ['prod', ...basicAudienceDisplayOrder]
const notFollowingOption: SelectOption[] = [{ value: '', name: '-none-' }]
const AudienceSwitch = () => {
  const isMobile = getIsMobile()
  const dispatch = useAppDispatch()
  const audience = useAppSelector(selectAudience)
  const ownedMatchSlug = useAppSelector(selectOwnedMatchSlug)
  const peersWithBroadcastingStatus = useAppSelector(selectPeersByBroadcastingStatus)
  const broadcasterArray = peersWithBroadcastingStatus.map(({ name, isBroadcasting }) => ({
    value: name,
    disabled: !isBroadcasting,
  }))
  const followingArray = notFollowingOption.concat(broadcasterArray)
  const isProducer = !!ownedMatchSlug
  const workingOrder = isMobile
    ? mobileAudiences
    : isProducer
    ? allAudienceDisplayOrder
    : basicAudienceDisplayOrder
  const workingIndex = Math.max(0, workingOrder.indexOf(audience))
  const onClick = () => {
    const nextIndex = (workingIndex + 1) % workingOrder.length
    const nextAudience = workingOrder[nextIndex]
    userManager.audience = nextAudience
  }
  const onChoosePeerToFollow = (event: ChangeEvent<HTMLInputElement>) => {
    const newPeerToFollow = event.target.value
    dispatch(tuneToChannel(newPeerToFollow))
  }
  const buttonTitle = `${isMobile ? '' : 'Mode '}${allAudienceLabels[audience]}`
  return (
    <div className="audienceSwitch">
      <button onClick={onClick}>{buttonTitle}</button>
      {audience === 'follow' && (
        <SelectWithLabel itemArray={followingArray} label="" onChange={onChoosePeerToFollow} />
      )}
    </div>
  )
}

export default AudienceSwitch
